(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9835],{

/***/ 78760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/my-shoppers-poshmark/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-01-22",
      tag: "Poshmark",
      title: "Poshmark My Shoppers: The New Tool Every Seller Should Benefit From",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Learn all about this new data-driven feature that leverages likes, bundles, and comments to get you closer to securing sales.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Poshmark may well be considered a trailblazer in its industry for regularly coming up with helpful seller tools, from Bulk Listing Actions to Style Tags and Listing Videos. Relevant tools that offer robust support to its vibrant seller community are developed by their Seller Experience Team and these are typically unveiled at the annual PoshFest. During the recently held virtual event, Poshmark CEO Manish Chandra introduced My Shoppers, a feature that aims to unlock new levels of growth for both old and new sellers by maximizing the data gathered from previous and potential buyers.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Powered by best-in-class technology that yields razor-like precision, My Shoppers allows a seller to launch a specific course of engagement with a customer based on their interaction with listings. This works like an online version of a brick-and-mortar boutique wherein a sales attendant encourages a potential customer to check out new arrivals or marked-down merchandise, or encourages an upsell by suggesting additional items that would complement what\u2019s already in a buyer\u2019s shopping cart.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Data is gold in today\u2019s digital economy. The future of shopping needs sales data to thrive. But, to quote the newly announced Poshmark co-founder Tracy Sun in her interview with Forbes, data is \u201Cpretty useless on its own.\u201D According to her, data comes to life when you pair it with insights and actions. My Shoppers is the action taken from My Closet Insights, another seller tool released recently that showcases a dynamic dashboard and a real time inventory. Together, these tools guide sellers in nudging a lead towards a sales funnel with the end goal of purchase.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Available to all sellers where Poshmark operates (the United States, Canada, Australia, India), My Shoppers is accessible on both web and app, just locate the \u201CMy Shoppers\u201D button on either the Account Tab or by clicking your display photo on the top right corner.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["You may choose which data to see (likers/bundlers/past buyers), and for it to be arranged in your preferred order based on the number of likes or bundled items, or recent shopper activity. Your customized My Shopper List will then be generated. You may also use this feature to view information such as your previous buyers from months ago or even from the past year.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["As mentioned earlier, data is practically useless if you don\u2019t take action. My Shoppers lets you do the following actions to your Shoppers List. Note though that the first two are mass actions that apply to all Poshers under that specific list.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "For Your List of Likers"
        }), ": Poshers who have liked an available listing from your closet will be automatically added to this list. Your task is to ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "add shoppers\u2019 likes to a bundle"
        }), ". Gather relevant items that would look great bundled with their liked item/s. This is a good chance to not just remind them of an item they\u2019ve liked, but also inform them that they will get to save on shipping if they buy it along with other items in the bundle."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "For Your List of Bundlers"
        }), ": Poshers who have shown interest in at least one item in your bundle will be added to this list. Your task is to ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "send offers to those bundles"
        }), ". Nudge them further to purchase by dangling irresistible bundle discounts.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "To Seal the Deal"
        }), ": Take it to the next level by ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "sending comments directly"
        }), " to those considering your bundles. This is your opportunity to provide personalized service and extend a special seller discount, shipping discount, or other promotional discounts to finally close the sale. Make it work a bit more to your advantage by timing your message on a payday Friday or weekend when people are more inclined to spend.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Social commerce is dynamic, that\u2019s why innovations are continuously introduced to help sellers engage intelligently with their shoppers. Sellers need to be willing to learn to use and leverage the latest tool or trend if they want to improve their business performance and scale up their business in a sustainable way.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Passion and ambition to succeed in a social marketplace are important, and so does a seller\u2019s time commitment. Save on precious time by letting OneShop automate the repetitive tasks (e.g. growing your followings, sharing your or others\u2019 listings) that help you reach new levels of success. This way, you have more time and energy to devote to strategizing and thrifting great items to sell. Bonus: OneShop also works with other platforms like Mercari, which makes relisting easier. Sign up for a free trial to experience what we mean.", ' ']
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/my-shoppers-poshmark.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Poshmark My Shoppers: The New Tool Every Seller Should Benefit From"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Learn all about this new data-driven feature that leverages likes, bundles, and comments to get you closer to securing sales."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/my-shoppers-poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/my-shoppers-poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Poshmark My Shoppers: The New Tool Every Seller Should Benefit From"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Learn all about this new data-driven feature that leverages likes, bundles, and comments to get you closer to securing sales."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-01-22T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-01-22T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 67511:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/my-shoppers-poshmark",
      function () {
        return __webpack_require__(78760);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(67511); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);